var _defs, _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoundtableIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 841.59 841.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 420.8,
    cy: 420.8,
    r: 420.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.09,
    y: 604.92,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "matrix(0.84, -0.54, 0.54, 0.84, -289.82, 254.09)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_2",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.95,
    y: 562.99,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(-165.64 101.51) rotate(-17.95)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_3",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.23,
    y: 510.55,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(-26.65 11.24) rotate(-2.95)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_4",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.24,
    y: 451.17,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(100.78 -28.57) rotate(12.05)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_5",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.26,
    y: 388.9,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(202.33 -39.27) rotate(27.05)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_6",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 327.98,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(278.21 -43.76) rotate(42.05)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_7",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.05,
    y: 272.55,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(341.27 -58.65) rotate(57.05)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_8",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.98,
    y: 226.41,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(411.25 -88.56) rotate(72.05)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_9",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 215.42,
    y: 192.7,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(507.04 -124.31) rotate(87.05)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_10",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.8,
    y: 173.7,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(639 -145.45) rotate(102.05)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_11",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.07,
    y: 170.72,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(803.78 -126.5) rotate(117.05)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_12",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 183.96,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(983.02 -45.1) rotate(132.05)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_13",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.42,
    y: 212.51,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(1146.48 110.1) rotate(147.05)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_14",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.56,
    y: 254.44,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(1258.98 334.17) rotate(162.05)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_15",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533.27,
    y: 306.88,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(1289.22 604.7) rotate(177.05)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_16",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 552.27,
    y: 366.26,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "matrix(-0.98, -0.21, 0.21, -0.98, 1218.21, 885.23)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_17",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 555.25,
    y: 428.53,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(1045.18 1132.61) rotate(-152.95)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_18",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 542.01,
    y: 489.46,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(789.04 1306.33) rotate(-137.95)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_19",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 513.46,
    y: 544.88,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(485.26 1377.65) rotate(-122.95)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_20",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 471.53,
    y: 591.02,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(178.59 1336.07) rotate(-107.95)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_21",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 419.09,
    y: 624.74,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(-86.42 1191.56) rotate(-92.95)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_22",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359.71,
    y: 643.73,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(-274.81 971.98) rotate(-77.95)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_23",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 297.44,
    y: 646.71,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(-368.1 716.35) rotate(-62.95)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_24",
    "data-name": "<Radial Repeat>"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 236.51,
    y: 633.47,
    width: 207.08,
    height: 24.16,
    rx: 1.63,
    transform: "translate(-367.08 465.72) rotate(-47.95)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundtableIcon);
export default __webpack_public_path__ + "static/media/roundtable-icon.aa10eddd8cb44f2e9324bb6649d881f9.svg";
export { ForwardRef as ReactComponent };